import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function ClarkPage() {
  const interestFormUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSdEZFiUXmZFW6clW-a7UL9S9BNCoTCw6YJIY0YlFLBoJuZ02Q/viewform";

  return (
  <>
    <Seo
  title="Άδεια Χειριστή Κλαρκ – ΚΔΒΜ2 ΘΗΣΕΑΣ"
  description="Εκπαίδευση και διαδικασία για απόκτηση άδειας χειριστή κλαρκ με θεωρία, πρακτική και καθοδήγηση από το ΚΔΒΜ2 ΘΗΣΕΑΣ."
  keywords="άδεια χειριστή κλαρκ, κλαρκ, περονοφόρο, κατάρτιση χειριστή, ΘΗΣΕΑΣ"
  url="https://theseus.edu.gr/clark"
  image="/clark.jpg"
  structuredData={{
    "@context": "https://schema.org",
    "@type": "Course",
    name: "Άδεια Χειριστή Κλαρκ",
    description: "Εκπαίδευση για απόκτηση άδειας χειριστή κλαρκ με θεωρία και πρακτική.",
    provider: {
      "@type": "EducationalOrganization",
      name: "ΚΔΒΜ2 ΘΗΣΕΑΣ",
      url: "https://theseus.edu.gr"
    }
  }}
/>
    <section className="min-h-screen bg-white">
      {/* HERO */}
      <div
        className="relative h-[320px] md:h-[420px] bg-cover bg-right"
        style={{ backgroundImage: "url(/clark.jpg)" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 h-full flex flex-col justify-end pb-10">
          <nav className="text-sm text-white/80 mb-3">
            <Link to="/" className="hover:underline">
              Αρχική
            </Link>
            <span className="mx-2">→</span>
            <Link to="/#programs" className="hover:underline">
              Προγράμματα
            </Link>
            <span className="mx-2">→</span>
            <span className="text-white">Άδεια Χειριστή Κλαρκ</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-extrabold text-white">
            Απόκτηση Άδειας Χειριστή Κλαρκ
          </h1>

          <p className="mt-3 max-w-3xl text-white/90">
            Οι ενδιαφερόμενοι αποκτούν τη δυνατότητα να ασκήσουν την επαγγελματική
            δραστηριότητα ολοκληρώνοντας το πρόγραμμα επαγγελματικής κατάρτισης και την
            αξιολόγηση που ακολουθεί.
          </p>

          <div className="mt-4 flex flex-wrap gap-2">
            <span className="inline-flex rounded-full bg-white/90 px-3 py-1 text-xs font-semibold">
              Άδεια / Βεβαίωση
            </span>
            <span className="inline-flex rounded-full bg-white/90 px-3 py-1 text-xs font-semibold">
              Θεωρία & Πρακτική
            </span>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* LEFT */}
        <div className="lg:col-span-2 space-y-10">
          {/* Intro */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Περιγραφή</h2>
            <p className="text-gray-700 leading-relaxed">
              Η κατοχή άδειας χειριστή κλαρκ καθίσταται πλέον υποχρεωτική για εργαζόμενους
              σε σχετιζόμενες επιχειρήσεις, ενώ σύμφωνα με το ΦΕΚ 3350/Β/12/12-06/2024, η
              διαδικασία απόκτησης της άδειας απλοποιείται.
            </p>

            <div className="rounded-2xl border border-gray-200 p-5 bg-gray-50">
              <h3 className="font-extrabold mb-2">Συγκεκριμένα</h3>
              <p className="text-gray-700 leading-relaxed">
                Όλοι οι ενδιαφερόμενοι μπορούν να αποκτήσουν άδεια για την άσκηση της
                επαγγελματικής δραστηριότητας ως χειριστές μηχανημάτων έργων συνολικής
                ισχύος κινητήρων άνω των δέκα (10) KW μέγιστης ανυψωτικής ικανότητας έως
                δύο χιλιάδων πεντακοσίων (2.500) kg της Ομάδας Β (έως 120 KW), ήτοι:
              </p>

              <ul className="mt-4 list-disc pl-5 text-gray-700 space-y-2">
                <li>
                  Ανυψωτικά περονοφόρα μηχανήματα (τύπου ΚΛΑΡΚ, κ.λπ.) και λοιπών τύπων
                  παντός συστήματος και λειτουργίας (πλην των ηλεκτροκίνητων) και
                </li>
                <li>
                  Ηλεκτροκίνητα περονοφόρα ανυψωτικά μηχανήματα (τύπου ΚΛΑΡΚ, κ.λπ.)
                  παντός τύπου
                </li>
              </ul>
            </div>
          </section>

          {/* What you get */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Τι αναλαμβάνει το ΚΔΒΜ Θησέας</h2>
            <p className="text-gray-700 leading-relaxed">
              Το ΚΔΒΜ Θησέας αναλαμβάνει την υλοποίηση του προγράμματος, ενώ με την
              ολοκλήρωσή του ο καταρτιζόμενος λαμβάνει άμεσα βεβαίωση επιτυχούς
              παρακολούθησης για την ένταξη στο Ενιαίο Μητρώο Προσώπων, που ασκούν Τεχνικά
              Επαγγέλματα και έχει δικαίωμα άσκησης ελεύθερου επαγγέλματος ως χειριστής
              μηχανημάτων έργων.
            </p>
          </section>

          {/* Audience */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Η απόφαση απευθύνεται σε</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
              <li>Βιομηχανίες και Επιχειρήσεις που διαθέτουν Περονοφόρα Οχήματα</li>
              <li>Εργαζόμενους σε Βιομηχανικό Περιβάλλον</li>
              <li>Χειριστές και Συντηρητές Μηχανημάτων Έργου</li>
              <li>Τεχνικούς και Μηχανικούς Ασφαλείας</li>
              <li>Υπεύθυνους αποθηκών και εργοδηγούς</li>
              <li>Ενδιαφερόμενους που επιθυμούν να εργαστούν ως Χειριστές ΚΛΑΡΚ</li>
            </ul>
          </section>

          {/* Requirements */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Προϋποθέσεις συμμετοχής</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
              <li>Ηλικία: τουλάχιστον 18 ετών</li>
              <li>Απολυτήριο τουλάχιστον υποχρεωτικής εκπαίδευσης</li>
              <li>Δίπλωμα οδήγησης Β κατηγορίας</li>
            </ul>
          </section>

          {/* Documents */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Απαιτούμενα δικαιολογητικά</h2>
            <p className="text-gray-700 leading-relaxed">
              Τα ενδιαφερόμενα φυσικά πρόσωπα προσκομίζουν στους Φορείς Υλοποίησης του
              προγράμματος κατάρτισης:
            </p>

            <div className="rounded-2xl border border-gray-200 p-5">
              <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                  <span className="font-semibold">α)</span> Αίτηση συμμετοχής στο πρόγραμμα
                  επαγγελματικής κατάρτισης (συμπληρώνεται στο Κέντρο μας),
                </li>
                <li>
                  <span className="font-semibold">β)</span> Φωτοτυπία ταυτότητας ή
                  διαβατηρίου (για πολίτες εκτός Ε.Ε. και άδειας παραμονής ή εργασίας),
                </li>
                <li>
                  <span className="font-semibold">γ)</span> Τίτλο σπουδών,
                </li>
                <li>
                  <span className="font-semibold">δ)</span> Φωτοαντίγραφο άδειας οδήγησης
                  τουλάχιστον Β΄ κατηγορίας,
                </li>
                <li>
                  <span className="font-semibold">ε)</span> Πιστοποιητικά υγείας από
                  δημόσιο φορέα, για:
                  <ul className="mt-2 list-disc pl-5 space-y-1">
                    <li>αρτιμέλεια (από παθολόγο ή ορθοπεδικό ή γενικό γιατρό),</li>
                    <li>για ακοή (από ΩΡΛ),</li>
                    <li>για όραση (από οφθαλμίατρο),</li>
                  </ul>
                </li>
                <li>
                  <span className="font-semibold">στ)</span> Υπεύθυνη δήλωση του άρθρου 8
                  του ν. 1599/1983 στην οποία δηλώνεται:
                  <ul className="mt-2 list-disc pl-5 space-y-1">
                    <li>
                      i) ότι τα προσκομιζόμενα δικαιολογητικά / στοιχεία είναι ακριβή και
                      αληθή,
                    </li>
                    <li>
                      ii) η οικεία σας Περιφέρεια, ήτοι η Περιφέρεια στην οποία αντιστοιχεί
                      η διεύθυνση επαγγελματικής εγκατάστασης ή μόνιμης διαμονής σας.
                      <span className="block text-gray-500 mt-1">
                        (Θα σας αποσταλεί το κείμενο.)
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          {/* Hours */}
          <section className="space-y-4">
            <h2 className="text-xl font-extrabold">Διάρκεια & Υλοποίηση</h2>
            <p className="text-gray-700 leading-relaxed">
              Το πρόγραμμα θα υλοποιηθεί με{" "}
              <span className="font-semibold">12 ώρες δια ζώσης</span> εκπαίδευσης και{" "}
              <span className="font-semibold">60 ώρες πρακτικής άσκησης</span>.
            </p>
          </section>

 {/* CTA */}
<section className="rounded-2xl bg-gray-900 text-white p-8 text-center">
  <h2 className="text-lg md:text-xl font-extrabold">
    ΦΟΡΜΑ ΕΚΔΗΛΩΣΗΣ ΕΝΔΙΑΦΕΡΟΝΤΟΣ
  </h2>

  <p className="mt-3 text-white/85">
    Επικοινωνήστε μαζί μας στο{" "}
    <span className="font-semibold">2510600205</span>.
  </p>

  <div className="mt-6">
    <a
      href={interestFormUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full rounded-xl bg-white text-gray-900 px-5 py-4 font-bold text-center hover:bg-gray-100 transition"
    >
      Φόρμα Εκδήλωσης Ενδιαφέροντος
    </a>
  </div>
</section>
        </div>

        {/* RIGHT SIDEBAR */}
        <aside className="space-y-6">
          <div className="rounded-2xl border border-gray-200 p-5">
            <h3 className="font-extrabold mb-4">Γρήγορες Πληροφορίες</h3>

            <div className="space-y-3 text-sm">
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Ελάχιστη ηλικία</span>
                <span className="font-semibold text-right">18 ετών</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Εκπαίδευση</span>
                <span className="font-semibold text-right">Υποχρεωτική</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Δίπλωμα</span>
                <span className="font-semibold text-right">Β κατηγορίας</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Υλοποίηση</span>
                <span className="font-semibold text-right">
                  12 ώρες δια ζώσης + 60 πρακτική
                </span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-gray-500">Τηλέφωνο</span>
                <span className="font-semibold text-right">2510 600205</span>
              </div>
            </div>

            <div className="mt-5 flex flex-col gap-2">
              <a
                href={interestFormUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-center rounded-xl bg-blue-600 px-4 py-3 font-bold text-white hover:bg-blue-700 transition"
              >
                Φόρμα Εκδήλωσης Ενδιαφέροντος
              </a>

              <a
                href="tel:2510600205"
                className="block text-center rounded-xl bg-gray-900 px-4 py-3 font-bold text-white hover:bg-black transition"
              >
                Καλέστε τώρα
              </a>
            </div>
          </div>

          <div className="rounded-2xl border border-gray-200 p-5">
            <h3 className="font-extrabold mb-2">Σημείωση</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Για πολίτες εκτός Ε.Ε. απαιτείται και άδεια παραμονής ή εργασίας. Για την
              υπεύθυνη δήλωση θα σας αποσταλεί το κείμενο.
            </p>
          </div>
        </aside>
      </div>
    </section>
  </>
);
}